import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral.gray[200]};
  .header-label {
    font-size: 15px;
    font-weight: 600;
  }
  input {
    width: 98%;
    margin: 10px;
    height: 40px;
    outline: none;
    border: none;
    background: ${({ theme }) => theme.neutral.white};
    border: 1px solid ${({ theme }) => theme.text.disabled};
    border-radius: 5px;
  }
`;
export const IconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
